/** Hilfsfunktionen zum Zerlegen eines From-/To-Headers in Name und Adresse. */

/** Extrahiert die reine E-Mail-Adresse aus einem Header wie `Name <a@b.de>`. */
export function absenderAdresse(header: string): string {
  const m = header.match(/<([^>]+)>/);
  if (m) return m[1].trim();
  return header.trim();
}

/** Liefert den Anzeigenamen, fällt auf die Adresse zurück, wenn keiner vorhanden ist. */
export function absenderName(header: string): string {
  const raw = (header || "").trim();
  const idx = raw.indexOf("<");
  if (idx > 0) {
    const name = raw.slice(0, idx).trim().replace(/^"|"$/g, "");
    if (name) return name;
  }
  return absenderAdresse(raw) || raw;
}

/**
 * Zerlegt ein Adressfeld (mehrere Empfänger, komma-getrennt) in reine Adressen.
 * Naiver Komma-Split – ausreichend für die übliche Header-Form `A <a@x>, B <b@y>`.
 */
export function alleAdressen(header: string): string[] {
  if (!header) return [];
  return header
    .split(",")
    .map((teil) => absenderAdresse(teil.trim()))
    .filter((a) => a.includes("@"));
}

/** Vereinigt mehrere Adresslisten, entfernt Duplikate und ausgeschlossene Adressen (case-insensitive). */
export function adressenZusammenfuehren(listen: string[][], ausschluss: string[] = []): string[] {
  const raus = new Set(ausschluss.map((a) => a.toLowerCase()));
  const gesehen = new Set<string>();
  const out: string[] = [];
  for (const liste of listen) {
    for (const a of liste) {
      const k = a.toLowerCase();
      if (!raus.has(k) && !gesehen.has(k)) {
        gesehen.add(k);
        out.push(a);
      }
    }
  }
  return out;
}
